import { render, staticRenderFns } from "./trip-view.vue?vue&type=template&id=4b82e152&scoped=true"
import script from "./trip-view.vue?vue&type=script&lang=js"
export * from "./trip-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b82e152",
  null
  
)

export default component.exports